export class SubUsersCollection {
  constructor() {
    this.users = [];
    this.limit = 20;
    this.page = 0;
    this.canLoad = true;
    this.initialized = false;
  }
}

export class PayoutsCollection {
  constructor(sortColumn = 'created_at') {
    this.payouts = [];
    this.limit = 20;
    this.page = 0;
    this.canLoad = true;
    this.initialized = false;
    this.total = 0;
    this.sortColumn = sortColumn;
    this.sortDirection = 0;
  }
}

export class ReferralsCollection {
  constructor() {
    this.referrals = [];
    this.limit = 20;
    this.page = 0;
    this.canLoad = true;
    this.initialized = false;
    this.total = 0;
  }
}